import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { history } from "../../redux-store/store";
function closeDropdown() {
    document.body.click();
}
const NavbarLink = props => {
    const isReactAppPath = history.location.pathname.startsWith("/app");
    const isReactRouteTarget =
        typeof props.to === "string" && props.to.startsWith("/app");

    return (
        <Fragment>
            {isReactAppPath && isReactRouteTarget ? (
                <Link {...props} onClick={closeDropdown}>
                    {props.label}
                </Link>
            ) : (
                <a href={props.to}>{props.label}</a>
            )}
        </Fragment>
    );
};

export default NavbarLink;
